<template>
  <div class="page-pod-detail">
    <pods-detail />
  </div>
</template>

<script>
import PodsDetail from '@/components/ask/details/PodsDetail.vue'

export default {
  name: 'ViewPodsDetail',
  components: {
    PodsDetail,
  },

  data() {
    return {
      pageName: 'PodsDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
